<template>
  <div class="flex items-center leading-[29]">
    <i v-if="conf.logoIcon" class="iconfont-logo t-[theme] mr-[5] t-[28]" :class="conf.logoIcon"></i>
    <img v-else-if="getCityAssetsFile('logo.png')" class="w-[28] mr-[5]" :src="getCityAssetsFile('logo.png')" alt="">
    <i class="icon t-[20] font-600 ff-yiBin">{{ conf.name }}</i>
  </div>
</template>
<script>

import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: 'dg-logo',
  data() {
    return {}
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style scoped></style>
